jQuery('.sub-menu-list-item').has('img').addClass('sub-menu-list-item--hasImage');